import request from "@/utils/request";
//注册新用户
export function Register(data) {
  return request({
    url: `/fmsapi/common/Register`,
    method: "post",
    data,
  });
}
